/**
 * 印尼语（id）
 */

import idLocale from 'element-ui/lib/locale/lang/id'

export default {
  ...idLocale,
  common: {},
  // 语言
  lang: {
    english: 'Inggris',
    spanish: 'Spanyol',
    japanese: 'Jepang',
    portuguese: 'Portugis',
    french: 'Perancis',
    russian: 'Russian',
    arabic: 'Arab',
    german: 'Jerman',
    italian: 'Italia',
    vietnam: 'Vietnam',
    turkey: 'Turki',
    korean: 'Korea',
    thai: 'Thai',
    dutch: 'Belanda',
    hebrew: 'Hebrew',
    indonesian: 'Indonesian'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {}

  // 张丰

  // 孙泽严
}
